import { useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Nav.css";

function Navbar() {
  const navRef = useRef();

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  const closeNavbar = () => {
    navRef.current.classList.remove("responsive_nav");
  };

  return (
    <>
      <div className="hello">
        <header>
          <h3>PAYROLL MANAGEMENT</h3>
          <nav ref={navRef} style={{ zIndex: 0 }}>
            <Link to="/" onClick={closeNavbar}>
              Home
            </Link>
            <Link to="/emp" onClick={closeNavbar}>
              Employees
            </Link>
            <Link to="/dept" onClick={closeNavbar}>
              Department
            </Link> 
            
              <Link to="/payroll" onClick={closeNavbar}>
                Payroll 
            </Link>


            <Link to="/crud" onClick={closeNavbar}>
                New Employee
            </Link>


            <Link to="/modify" onClick={closeNavbar}>
              Update
            </Link>
         
            <button className="nav-btn nav-close-btn" onClick={showNavbar}>
              <FaTimes />
            </button>
          </nav>
          <button className="nav-btn" onClick={showNavbar}>
            <FaBars />
          </button>
        </header>
      </div>
      <br />
      <br />
      <br />
      <br />
     
      <div className="aboveboxcontainer" style={{ zIndex: 0 }}>
        <div className="box-container">
          {/* Box content goes here */}
        </div>
      </div>
    </>
  );
}

export default Navbar;
